import { render, staticRenderFns } from "./DocInterface.vue?vue&type=template&id=b5c40c52&"
import script from "./DocInterface.vue?vue&type=script&lang=js&"
export * from "./DocInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports